import { DurationFunc } from "../duration";
import { LOCAL_DATE_TIME_FORMAT } from "../time-format";
import { LocalDateTimeFunc } from "./local-date-time";
export class DateTimeRange {
    v;
    constructor(v) {
        this.v = v;
    }
    static of({ startAt: startAtValues, endAt: endAtValues, }) {
        const startAt = LocalDateTimeFunc.of(startAtValues);
        const endAt = LocalDateTimeFunc.of(endAtValues);
        return this.between({ startAt, endAt });
    }
    static between({ startAt, endAt }) {
        return new DateTimeRange({ startAt, endAt });
    }
    floor(precision) {
        return DateTimeRange.between({
            startAt: this.v.startAt.floor(precision),
            endAt: this.v.endAt.floor(precision),
        });
    }
    duration() {
        return DurationFunc.between(this.v);
    }
    /**
     * @returns 指定した時間帯と重なっている時間幅を取得する。全く重なっていなければゼロ。
     */
    getOverlapTime(other) {
        // --S1--S2---E1--E2-- -> S2-E1
        // --S1--E1---S2--E2-- -> ZERO
        const lateStart = this.v.startAt.isBefore(other.v.startAt)
            ? other.v.startAt
            : this.v.startAt;
        const earlyEnd = this.v.endAt.isBefore(other.v.endAt)
            ? this.v.endAt
            : other.v.endAt;
        if (earlyEnd.isBefore(lateStart)) {
            return DurationFunc.ZERO;
        }
        return DurationFunc.between({ startAt: lateStart, endAt: earlyEnd });
    }
    isNotAcrossDays() {
        return this.v.startAt.toLocalDate().equals(this.v.endAt.toLocalDate());
    }
    toValues() {
        return {
            startAt: this.v.startAt.toValues(),
            endAt: this.v.endAt.toValues(),
        };
    }
    format(dateTimeFormat) {
        const startString = this.v.startAt.format(dateTimeFormat);
        const endString = this.v.endAt.format(dateTimeFormat);
        if (startString === endString) {
            return startString;
        }
        return `${startString}~${endString}`;
    }
    toString() {
        return this.format(LOCAL_DATE_TIME_FORMAT);
    }
}
//# sourceMappingURL=date-time-range.js.map